import {
  Configuration,
  ProtocolMode,
  PublicClientApplication,
} from "@azure/msal-browser";

const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID || "";

// Entra endpoints are proxied through Apigee, so the default
// login.microsoftonline.com metadata discovery must be overridden with the real Apigee URLs
const authorityMetadata = JSON.stringify({
  issuer: `https://login.microsoftonline.com/${tenantId}/v2.0`,
  authorization_endpoint: process.env.REACT_APP_ENTRA_AUTHORIZE_ENDPOINT || "",
  token_endpoint: process.env.REACT_APP_ENTRA_TOKEN_ENDPOINT || "",
  end_session_endpoint: process.env.REACT_APP_ENTRA_LOGOUT_ENDPOINT || "",
  jwks_uri: process.env.REACT_APP_ENTRA_JWKS_ENDPOINT || "",
});

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${tenantId}`,
    authorityMetadata,
    // Endpoints are proxied through Apigee with a non-standard path shape (extra
    // segments before the tenant id), which breaks MSAL's default AAD tenant-path
    // substitution (it assumes the first path segment after the host is the tenant
    // id). OIDC protocol mode skips that substitution and uses authorityMetadata as-is.
    protocolMode: ProtocolMode.OIDC,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const ENTRA_LOGIN_SCOPES = ["openid", "profile", "email"];

// Constructed lazily - the constructor requires the Web Crypto API, which isn't
// available at module-import time in some environments (e.g. Jest/jsdom).
let msalInstance: PublicClientApplication | null = null;

export const getMsalInstance = (): PublicClientApplication => {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(msalConfig);
  }
  return msalInstance;
};
